/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Update_Vertical_LabelInputs */

const en_position_modal_update_vertical_label = /** @type {(inputs: Position_Modal_Update_Vertical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Vertical`)
};

const fr_position_modal_update_vertical_label = /** @type {(inputs: Position_Modal_Update_Vertical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre a jour le vertical`)
};

const de_position_modal_update_vertical_label = /** @type {(inputs: Position_Modal_Update_Vertical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertikales Update`)
};

const it_position_modal_update_vertical_label = /** @type {(inputs: Position_Modal_Update_Vertical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna verticale`)
};

const ru_position_modal_update_vertical_label = /** @type {(inputs: Position_Modal_Update_Vertical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить вертикаль`)
};

const es_position_modal_update_vertical_label = /** @type {(inputs: Position_Modal_Update_Vertical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar vertical`)
};

const zh_cn2_position_modal_update_vertical_label = /** @type {(inputs: Position_Modal_Update_Vertical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`垂直更新`)
};

const ja_position_modal_update_vertical_label = /** @type {(inputs: Position_Modal_Update_Vertical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`垂直方向の更新`)
};

const hi_position_modal_update_vertical_label = /** @type {(inputs: Position_Modal_Update_Vertical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्टिकल अपडेट करें`)
};

const pt_pt2_position_modal_update_vertical_label = /** @type {(inputs: Position_Modal_Update_Vertical_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização Vertical`)
};

/**
* | output |
* | --- |
* | "Update Vertical" |
*
* @param {Position_Modal_Update_Vertical_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_update_vertical_label = /** @type {((inputs?: Position_Modal_Update_Vertical_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Update_Vertical_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_modal_update_vertical_label(inputs)
	if (locale === "de") return de_position_modal_update_vertical_label(inputs)
	if (locale === "it") return it_position_modal_update_vertical_label(inputs)
	if (locale === "ru") return ru_position_modal_update_vertical_label(inputs)
	if (locale === "es") return es_position_modal_update_vertical_label(inputs)
	if (locale === "zh-CN") return zh_cn2_position_modal_update_vertical_label(inputs)
	if (locale === "ja") return ja_position_modal_update_vertical_label(inputs)
	if (locale === "hi") return hi_position_modal_update_vertical_label(inputs)
	if (locale === "pt-PT") return pt_pt2_position_modal_update_vertical_label(inputs)
	return en_position_modal_update_vertical_label(inputs)
});